import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class FileDownloadService {

  /**
   * Esegue il download di un file ricevuto come HttpResponse<Blob>.
   * Il nome del file viene estratto automaticamente dall'header
   * Content-Disposition (incluso il formato RFC 5987 `filename*=UTF-8''...`).
   * Se l'header è assente o malformato, usa `fallbackFilename`.
   */
  downloadFromResponse(res: HttpResponse<Blob>, fallbackFilename: string): void {
    const blob = res.body as Blob;
    const disposition = res.headers.get('Content-Disposition') ?? '';
    const filename = this.extractFilename(disposition, fallbackFilename);
    this.triggerDownload(blob, filename);
  }

  // ─── Private ──────────────────────────────────────────────────────────────

  private extractFilename(disposition: string, fallback: string): string {
    const match = /filename\*?=(?:UTF-8'')?\"?([^";]+)\"?/i.exec(disposition);
    return match ? decodeURIComponent(match[1]) : fallback;
  }

  private triggerDownload(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  }
}
